export function modifyCategory(categoryName) {
  const parts = categoryName.toLowerCase().split(" ");
  let modifiedCategory = categoryName.toLowerCase();
  if (parts.length > 1) {
    modifiedCategory = parts.join("_");
  }
  return modifiedCategory;
}
